var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1112_3393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3375 6.12762C25.5786 5.95798 25.6352 5.62508 25.4655 5.38502C25.2969 5.14068 24.9587 5.08627 24.7229 5.25698L23.5044 6.11695C23.5023 6.11909 23.4991 6.11909 23.497 6.12016C23.4948 6.12229 23.4938 6.12442 23.4916 6.12549L16.0378 11.3878C15.4617 10.8372 14.6849 10.4936 13.8271 10.4936C12.0623 10.4936 10.6262 11.9298 10.6262 13.6945C10.6262 15.4593 12.0623 16.8954 13.8271 16.8954C15.5918 16.8954 17.028 15.4593 17.028 13.6945C17.028 13.1717 16.8903 12.6852 16.6673 12.2488L23.6666 7.30769C24.9043 9.21009 25.5637 11.4048 25.5637 13.6945C25.5637 13.989 25.8027 14.228 26.0972 14.228C26.3916 14.228 26.6306 13.989 26.6306 13.6945C26.6306 11.1829 25.903 8.7769 24.5373 6.69312L25.3375 6.12762ZM13.8271 15.8285C12.6502 15.8285 11.6931 14.8714 11.6931 13.6945C11.6931 12.5177 12.6502 11.5606 13.8271 11.5606C15.0039 11.5606 15.961 12.5177 15.961 13.6945C15.961 14.8714 15.0039 15.8285 13.8271 15.8285Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08432 13.6915C2.08432 7.22033 7.34979 1.95486 13.8209 1.95486C16.6249 1.95486 19.3403 2.95994 21.4647 4.78445C21.6887 4.97757 22.0259 4.9509 22.2169 4.7279C22.41 4.50384 22.3833 4.16774 22.1603 3.97569C19.8418 1.98367 16.8799 0.887894 13.8209 0.887894C6.76083 0.887894 1.01735 6.63137 1.01735 13.6915C1.01735 13.986 1.25635 14.225 1.55084 14.225C1.84532 14.225 2.08432 13.986 2.08432 13.6915Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1112_3393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0326,
    height: 16.4274,
    fill: "white",
    transform: "translate(0.809814 0.677536)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSelected);
export default __webpack_public_path__ + "static/media/dashboard-selected.0762c04189f9b2b42b3ede70144de59d.svg";
export { ForwardRef as ReactComponent };